import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { musinsaSnapClient } from '../musinsaSnapClient';
import { createApiResponseSchema } from '../utils';
import { snapLikeApiPath } from './apiPath';

const GetLikedSnapsCountRequestSchema = z
  .object({
    ids: z.array(z.string()),
  })
  .describe('GetLikedSnapsCountRequestSchema');

export type GetLikedSnapsCountRequest = z.infer<typeof GetLikedSnapsCountRequestSchema>;

const FindLikedSnapResultSchema = z
  .object({
    likeCount: z.number().int().nonnegative().optional(),
    isExists: z.boolean(),
  })
  .describe('FindLikedSnapResultSchema');

const GetLikedSnapsCountDataSchema = z
  .record(z.string(), FindLikedSnapResultSchema)
  .describe('GetLikedSnapsCountDataSchema');

export const GetLikedSnapsCountResponseSchema = createApiResponseSchema(
  GetLikedSnapsCountDataSchema,
).describe('GetLikedSnapsCountResponseSchema');

export type GetLikedSnapsCountResponse = z.infer<typeof GetLikedSnapsCountResponseSchema>;

export const getLikedSnapsCount = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetLikedSnapsCountRequestSchema),
    async (params: GetLikedSnapsCountRequest): Promise<GetLikedSnapsCountResponse> =>
      executeStandardRequest(async () => {
        const query: Record<string, string> = { ids: params.ids.join(',') };
        return musinsaSnapClient.get<GetLikedSnapsCountResponse>(
          snapLikeApiPath.getLikedSnapsCount,
          query,
        );
      }),
    validateApiResponse(GetLikedSnapsCountResponseSchema),
  ),
);
